<button class="btn btn-secondary btn-default" *ngIf="chosenClient == null && !options.onlySearch || !options.showResult && !options.onlySearch" data-toggle="modal" [attr.data-target]="'#searchCustomer' + inputId" (click)="isSearching = true; who = ''; getCustomersPagination(startIndex, endIndex)">{{ 'Offers.Search' | translate }} {{ ('Standard.Customer' | translate ) | lowercase }}</button>
<button class="btn btn-secondary" *ngIf="chosenClient != null && options.showResult && !options.onlySearch" (click)="chosenClient = null;chosen.emit(null); who = ''">
  <div *ngIf="chosenClient != null && chosenClient.customerNumber != null">{{ chosenClient.customerNumber }}</div>
  <div>
    <b *ngIf="chosenClient.customerName">{{ chosenClient.customerName }}</b>
  </div>
  <div>{{ chosenClient.invoiceZipCode}} {{ chosenClient.invoiceCity}}</div>
</button>
<input class="form-control" type="text" name="customers" autocomplete="off" (keydown)="search()" [(ngModel)]="who" placeholder="{{ 'Offers.Search' | translate }} {{ ('Standard.Customer' | translate ) | lowercase }}" *ngIf="options.onlySearch" />

<div *ngIf="options.onlySearch">
  <table class="table table-striped table-sm"
         id="customerTable"
         infinite-scroll
         [infiniteScrollDistance]="scrollDistance"
         [infiniteScrollUpDistance]="scrollUpDistance"
         [infiniteScrollThrottle]="throttle"
         [infiniteScrollContainer]="'#customerTable'"
         [fromRoot]="true"
         (scrolled)="onScrollDown()"
         aria-label="Customer list">
    <thead>
      <tr>
        <th style="width:10%">Kundenummer</th>
        <th style="width:10%">{{ 'Standard.Name' | translate }}</th>
        <th style="width:10%">{{ 'Standard.Phone' | translate }}</th>
        <th style="width:10%">{{ 'Standard.Mobile' | translate }}</th>
        <th style="width:40%">{{ 'Standard.Address' | translate }}</th>
        <th style="width:10%">{{ 'Standard.Zipcode' | translate }}</th>
        <th style="width:10%">{{ 'Standard.City' | translate }}</th>
        <th style="width:10%">{{ 'Standard.Email' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr class="singleCustomer" *ngFor="let c of output" (click)="chooseClient(c);close()">
        <td>{{ c.customerNumber }}</td>
        <td>{{ c.name }}</td>
        <td>{{ c.invoicePhone }}</td>
        <td>{{ c.invoiceMobile }}</td>
        <td>{{ c.invoiceAddress }}</td>
        <td>{{ c.invoiceZipCode }}</td>
        <td>{{ c.invoiceCity }}</td>
        <td>{{ c.invoiceEmail }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal" #searchCustomerModal [attr.id]="'searchCustomer' + inputId" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Offers.Search' | translate }} {{ ('Standard.Case' | translate ) | lowercase }}</h5>
        <button type="button" class="close" (click)="close()" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="isSearching && !options.onlySearch">
        <div class="row">
          <div class="col-6 d-flex">
            <input class="form-control" type="text" name="customers" autocomplete="off" (keydown)="search()" [(ngModel)]="who" placeholder="{{ 'Offers.Search' | translate }} {{ ('Standard.Customer' | translate ) | lowercase }}" />
            <button class="btn btn-success col-2 ml-1" (click)="search()">{{ 'Offers.Search' | translate }}</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <table
                   class="table table-striped table-sm"
                   id="customerTable"
                   infinite-scroll
                 [infiniteScrollDistance]="scrollDistance"
                 [infiniteScrollUpDistance]="scrollUpDistance"
                 [infiniteScrollThrottle]="throttle"
                  [infiniteScrollContainer]="'#customerTable'"
                  [fromRoot]="true"
                 (scrolled)="onScrollDown()"
                 aria-label="Customer table">
              <thead>
                <tr>
                  <th style="width:10%">Kundenummer</th>
                  <th style="width:10%">{{ 'Standard.Name' | translate }}</th>
                  <th style="width:10%">{{ 'Standard.Phone' | translate }}</th>
                  <th style="width:40%">{{ 'Standard.Address' | translate }}</th>
                  <th style="width:10%">{{ 'Standard.Zipcode' | translate }}</th>
                  <th style="width:10%">{{ 'Standard.City' | translate }}</th>
                  <th style="width:10%">{{ 'Standard.Email' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="singleCustomer" *ngFor="let c of output" (click)="chooseClient(c);close()">
                  <td>{{ c.customerNumber }}</td>
                  <td>{{ c.name }}</td>
                  <td>{{ c.invoicePhone }}</td>
                  <td>{{ c.invoiceAddress }}</td>
                  <td>{{ c.invoiceZipCode }}</td>
                  <td>{{ c.invoiceCity }}</td>
                  <td>{{ c.invoiceEmail }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer p-3 text-right">
        <div class="col-3">
          <button type="button" class="btn btn-secondary" (click)="close()">{{ 'Buttons.Close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
